
document.addEventListener('DOMContentLoaded', function () {
  const menu = document.querySelector('#small-screen-menu');
  const openButton = document.querySelector('.open-small-screen-menu');
  const closeButton = document.querySelector('.close-small-screen-menu');

  if (!menu || !openButton || !closeButton) return;

  function setMenuOpen(open) {
    menu.classList.toggle('is-open', open);
    menu.inert = !open;

    openButton.setAttribute('aria-expanded', String(open));
    openButton.setAttribute(
      'aria-label',
      open ? 'Menu geopend' : 'Menu openen'
    );

    closeButton.setAttribute('aria-expanded', String(open));
  }

  openButton.addEventListener('click', function () {
    setMenuOpen(true);
  });

  closeButton.addEventListener('click', function () {
    setMenuOpen(false);
    openButton.focus();
  });

  menu.addEventListener('click', function (event) {
    if (event.target.closest('a')) {
      setMenuOpen(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) {
      setMenuOpen(false);
      openButton.focus();
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 960) {
      setMenuOpen(false);
    }
  });

  setMenuOpen(false);
});